module.exports = __webpack_public_path__ + "static/media/fools.2a7e62b3.jpg";